import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useField } from 'formik'
import TextField from '@material-ui/core/TextField'
import InputAdornment from '@material-ui/core/InputAdornment'
import errorIcon from 'assets/fields/error.svg'
import { ErrorMessage } from 'components/Shared/ErrorMessage'
import makeStyles from '@material-ui/core/styles/makeStyles'
import classNames from 'classnames'
import { useValidationSchema } from 'context/validationSchema'
import { isFieldRequired } from 'components/Shared/FormikForm'

const useStyles = makeStyles({
  defaultStyles: {
    width: '310px',
    maxWidth: '100%'
  }
})

function defaultEndAdornmentRenderer (error, touched) {
  return !!error && touched
    ? (
      <InputAdornment position="end">
        <img
          src={errorIcon}
          style={{ height: 20 }} alt="Field warning"/>
      </InputAdornment>
    )
    : null
}

export function FieldComponent ({
  fieldName,
  label,
  type,
  disabled,
  skipErrorIcon = false,
  inputClassName,
  className,
  multiline,
  rowsMax = 10,
  rowsMin,
  endAdornmentRenderer = defaultEndAdornmentRenderer,
  requireTouchToShowError = true,
  required,
  inputProps,
  ...rest
}) {

  const { schema } = useValidationSchema()

  const [field, meta] = useField(fieldName)
  const { error, touched } = meta
  const { t } = useTranslation()
  const classes = useStyles()

  const isRequired = useMemo(() => isFieldRequired(schema, fieldName), [schema, fieldName])

  return (
    <TextField
      {...field}
      error={!!error && (!requireTouchToShowError || touched)}
      name={fieldName}
      key={fieldName}
      label={t(label)}
      type={type}
      variant="filled"
      disabled={disabled}
      required={required === undefined ? isRequired : required}
      helperText={<ErrorMessage name={fieldName}/>}
      InputProps={{
        classes: {
          input: inputClassName
        },
        disableUnderline: true,
        endAdornment: !skipErrorIcon && endAdornmentRenderer(error, touched),
        inputProps
      }}
      className={classNames(classes.defaultStyles, className)}
      multiline={multiline}
      maxRows={rowsMax}
      minRows={rowsMin}
      {...rest}
    />
  )
}
